import { render, staticRenderFns } from "./modalLocalizarContas.vue?vue&type=template&id=143f3316"
import script from "./modalLocalizarContas.vue?vue&type=script&lang=js"
export * from "./modalLocalizarContas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports